import { a767, a769, a710, a759, a770 } from "Components/Api/RootApiPath";

export const getAllCustomerTransaction = async ({ payload }) => {
  try {
    const response = await fetch(a767, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: payload.clientCode,
        CustomerId: payload.CustomerId,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching customer transactions:", error);
    throw new Error(
      error.message ||
        "Failed to fetch customer transactions. Please try again later."
    );
  }
};

export const addCustomerTransaction = async ({ payload }) => {
  try {
    const response = await fetch(a769, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching customer transactions:", error);
    throw new Error(
      error.message ||
        "Failed to fetch customer transactions. Please try again later."
    );
  }
};

export const updateCustomerBalanceAmount = async ({ payload }) => {
  try {
    const response = await fetch(a710, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating customer balance amount:", error);
    throw new Error(
      error.message ||
        "Failed to update customer balance amount. Please try again later."
    );
  }
};

export const getAllLabeledStock = async ({ payload }) => {
  try {
    const response = await fetch(a759, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching labeled stock:", error);
    throw new Error(
      error.message ||
        "Failed to fetch labeled stock. Please try again later."
    );
  }
};

export const addCustomerIssue = async ({ payload }) => {
  try {
    const response = await fetch(a770, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding customer issue:", error);
    throw new Error(
      error.message ||
        "Failed to add customer issue. Please try again later."
    );
  }
};
